import { useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface IGetAllFreebieRulesParams {
    limit: number;
    cursor: string | null;
    direction: string;
    search?: string;
    status?: number;
    type?: number;
    sortBy?: string;
    sortOrder?: string;
}

export const useGetAllFreebieRules = (
    queryKey: string | string[],
    parameters: IGetAllFreebieRulesParams,
) => {
    const auth = useAuth();
    return useQuery(queryKey, async () => {
        if (!auth.token) {
            throw new Error(
                "Cannot fetch freebie rules without authorization token.",
            );
        }

        return await api.freebieRule.fetchAllFreebieRules({
            ...parameters,
            token: auth.token,
        });
    });
};
